import en from "./en.js";
import fr from "./fr.js";
import indo from "./id.js";
import pt from "./pt.js";
import ar from "./ar.js";

export default {
  ar,
  en,
  fr,
  indo,
  "in-ID": indo,
  "pt-BR": pt,
  "pt-PT": pt,
};
